<template>
  <div ref="peserta">
    <m-card-list
      title="Peserta Kelas"
      search
      id-key
      @filter="filter"
      refresh
      :variablePencarian="[
        { key: 'Nama', value: 'nama' },
        { key: 'Surel', value: 'surel' }
      ]"
      @refresh="load"
      :items="items"
      footerLabel="Pengguna"
      @search="
        search => {
          dataPencarian = search;
          load();
        }
      "
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      footer
    >
      <template v-slot:filter>
        <v-divider></v-divider>
      </template>
      <template v-slot:items="{ item }">
        <v-row class="mx-3">
          <v-col cols="2" sm="2" md="1" lg="1" xl="1" class="d-none d-sm-flex" align="center" justify="center">
            <v-avatar :size="60" color="white">
              <v-icon size="50" color="primary">mdi-account-circle</v-icon>
            </v-avatar>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 12 : 10" sm="9" md="9" lg="10" xl="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="3" xl="3">
                <p class="caption black--text my-0 py-0">Nama</p>
                <p class="body-1 font-weight-bold my-0 py-0">
                  {{ pVal(item, "name") }}
                </p>
                <p class="blue--text caption">{{ pVal(item, "email_belajar_id") }}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Mapel</p>
                <p>{{item.info_guru.ptk.m_mapel_ukg.keterangan}}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Asal Sekolah</p>
                <p>{{item.info_guru.ptk.instansi}}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Kota/Kabupaten</p>
                <p>{{item.kelasenrol[0].kota_sekolah.provinsi.keterangan}} - {{item.kelasenrol[0].kota_sekolah.keterangan}}</p>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption grey--text my-0 py-0">Status</p>
                <span :class="!item.kelasenrol[0].completed_by?'warning--text':item.kelasenrol[0].is_complete == 1 ? 'success--text' : 'error--text'">{{
                    !item.kelasenrol[0].completed_by?'Belum diverval':item.kelasenrol[0].is_complete == 1 ? "Diterima" : "Ditolak"
                  }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1" xl="1">
            <p></p>
            <m-menu left style="float:right" :items="more_menu" :object="item" />
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>
    <FormVerval ref="dlgVerval" />
  </div>
</template>

<script>
import { isCan } from "@/tools";
import FormVerval from "../components/DetailVerval.vue";
import FilterPengguna from "@/filter/FilterPengguna.vue";

// @group Global Feature
export default {
  name: "kelas-peserta",
  components: {
    FilterPengguna,
    FormVerval
  },
  data() {
    return {
      items: [],
      textSearch: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      jumlahPengguna: 0,
      more_menu: [
        {
          title: "Verifikasi Peserta",
          icon: "mdi-account-check",
          color: "green",
          click: (i, o) => this.openVerval(o),
          check: () => isCan("verval")
        },
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    maxPengguna() {
      return this.jumlahPengguna > PESERTA_COACHING_CLINIC ? false : true;
    }
  },
  activated() {
    this.load();
  },
  mounted() {
    this.load();
  },
  props: {
    enroll: {
      type: Boolean,
      default: false
    },
    is_kelas_tutup: {
      type: Boolean,
      default: false
    },
    is_daring: {
      type: Boolean,
      default: false
    },
    is_nilai: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    load() {
      var params = {
        page: this.cp,
        peran_kelas: this.peran
      };
      if (this.dataPencarian) {
        var param = this.dataPencarian.param == "surel" ? "email" : this.dataPencarian.param;
        params[param] = this.dataPencarian.s;
      }
      return this.$store
        .dispatch("kelas/getPesertaKelas", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.jumlahPengguna = res.total;
          this.items = res.data;
        })
        .catch(e => e);
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    openVerval(val) {
      this.$refs.dlgVerval.open(val).then(() => {
        this.load();
      });
    },
  }
};
</script>
